'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.bestPageUrlFor = exports.bestDomainFor = undefined;

var _Yelp = require('./Yelp');

var Yelp = _interopRequireWildcard(_Yelp);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var bestDomainFor = exports.bestDomainFor = function bestDomainFor(locale) {
	var localeDomain = Yelp.localeDomains[locale];
	if (localeDomain) {
		return localeDomain;
	}

	return Yelp.localeDomains['en_US'];
};

var bestPageUrlFor = exports.bestPageUrlFor = function bestPageUrlFor(_ref) {
	var locale = _ref.locale,
	    id = _ref.id;

	var domain = Yelp.localeDomains[locale];
	if (domain) {
		return 'https://' + domain + '/biz/' + id;
	} else {
		return 'https://' + Yelp.localeDomains['en_US'] + '/biz/' + id + '?hl=' + locale;
	}
};